import React, { useEffect, useState } from 'react';

// Thin animated printer registration bar (CMYK + Pantones)
// Sticky at top of viewport; also mirrors scroll progress via a filled overlay
const ScrollColorBar = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const scrollTop = window.scrollY;
      const height = document.documentElement.scrollHeight - window.innerHeight;
      const p = height > 0 ? Math.min(100, (scrollTop / height) * 100) : 0;
      setProgress(p);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className="fixed top-0 left-0 right-0 z-[60] pointer-events-none">
      {/* Base spectrum */}
      <div
        className="h-[3px] w-full opacity-[0.85]"
        style={{
          backgroundImage:
            'linear-gradient(90deg, #00B7C7 0%, #00B7C7 12%, #E5007E 12%, #E5007E 24%, #FFD700 24%, #FFD700 36%, #0F7B3F 36%, #0F7B3F 48%, #003DA5 48%, #003DA5 60%, #FF6B35 60%, #FF6B35 72%, #6A0DAD 72%, #6A0DAD 84%, #050F2E 84%, #050F2E 100%)',
        }}
      />
      {/* Progress overlay */}
      <div
        className="absolute top-0 left-0 h-[3px] bg-[#050F2E]/85 transition-[width] duration-100"
        style={{ width: `${100 - progress}%`, right: 0, left: 'auto' }}
      />
    </div>
  );
};

export default ScrollColorBar;
